export const REPORTING_AI_ASSISTANT_FEEDBACK_TYPE = {
  NEGATIVE: 'negative',
  POSITIVE: 'positive'
};